// Replaces a collection in place so as not to break references
export function replaceCollection(collection: [], newObjs: []): void {
    collection.splice(0, collection.length);
    collection.push(...newObjs);
}